import PresortDemo from "../components/table/DataTable";
import { useRef, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { SpeedDial } from "primereact/speeddial";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useParams } from "react-router-dom";

import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import ShippingLabel from "../components/common/PrintOrderLabel";
import { generateTrackingCode } from "./SetUser";
import { useActionsHook } from "../hooks/useActionsHook";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";

import {
  useGetListBuyForMeQuery,
  useTakeBuyForMeToProcessingMutation,
} from "../store/api/buyForMeAPI";
import { useCreateOrUpdateOrderMutation } from "../store/api/orderAPI";
import { buyForMeColumn } from "../metadata/buyForMe";
import { t } from "i18next";
import { InputText } from "primereact/inputtext";

function BuyForMe() {
  const { id } = useParams();
  const { data, isLoading } = useGetListBuyForMeQuery();
  const [takeToProcessing, { isLoading: isProcessing }] =
    useTakeBuyForMeToProcessingMutation();
  const [createOrUpdateOrder] = useCreateOrUpdateOrderMutation();
  const toast = useRef(null);
  const [trackingNumber, setTrackingNumber] = useState("");
  const [processModal, setProcessModal] = useState({
    visible: false,
    data: null,
  });
  const printRef = useRef();
  const [printData, setPrintData] = useState(null);

  const orderColumnTr = useTranslatedColumns(buyForMeColumn);

  const actions = useActionsHook([
    {
      icon: "pi pi-plus",
      tooltip: t("takeToProcess"),
      onClick: (param, row) => {
        setProcessModal({ visible: true, data: row });
      },
    },
  ]);

  const items = [
    {
      label: "React Website",
      icon: "pi pi-external-link",
      command: () => {},
    },
  ];

  const [formData, setFormData] = useState({});
  const [visibleLeft, setVisibleLeft] = useState({
    visible: false,
    data: null,
  });

  const toggleSidebar = (bool, data) => {
    setFormData(data);
    setVisibleLeft({ visible: bool, data });
  };

  const onBlur = (e, attr, value) => {
    setFormData((state) => ({ ...state, [attr]: value }));
  };

  return (
    <>
      <Toast ref={toast} />

      {/* Модалка заявки */}
      <Dialog
        header="Заявка в обработку"
        visible={processModal.visible}
        style={{ width: "50vw" }}
        modal
        onHide={() => {
          setTrackingNumber("");
          setProcessModal({ visible: false, data: null });
        }}
      >
        {processModal.data && (
          <div className="process-modal">
            <div className="info-row">
              <b>Товар:</b> {processModal.data.name}
            </div>
            <div className="info-row">
              <b>Страна:</b> {processModal.data.country}
            </div>
            <div className="info-row">
              <b>Цена:</b> {processModal.data.price}
            </div>
            <div className="info-row">
              <b>Кол-во:</b> {processModal.data.amount}
            </div>
            <div className="info-row">
              <b>Итого:</b> {processModal.data.total_price}
            </div>
            <div className="info-row">
              <b>Email:</b> {processModal.data.email}
            </div>
            <div className="info-row">
              <b>Телефон:</b> {processModal.data.phone}
            </div>
            <div className="info-row">
              <b>Ссылка:</b>{" "}
              <a href={processModal.data.link} target="_blank" rel="noreferrer">
                открыть товар
              </a>
            </div>

            <div
              style={{
                marginTop: 20,
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              {processModal.data.status === 31 && (
                <div className="info-row" style={{ marginTop: 15 }}>
                  <b>Трек-номер:</b>
                  <div style={{ display: "flex", gap: 10, marginTop: 5 }}>
                    <InputText
                      value={trackingNumber}
                      onChange={(e) => setTrackingNumber(e.target.value)}
                      placeholder="Введите трек-номер"
                      style={{ flex: 1 }}
                    />
                    <MyButton
                      label="Сгенерировать"
                      type="button"
                      onClick={() => setTrackingNumber(generateTrackingCode())}
                    />
                  </div>
                </div>
              )}
              <div className="">
                {/* Кнопка взять в обработку */}
                {processModal.data.status !== 31 && (
                  <MyButton
                    label={isProcessing ? "Обработка..." : "Взять в обработку"}
                    onClick={async () => {
                      try {
                        alert(JSON.stringify(processModal.data));
                        await takeToProcessing({
                          guid: processModal.data.guid,
                          invoice_guid: processModal.data.invoice_guid,
                          user_email: processModal.data.email,
                        }).unwrap();

                        toast.current.show({
                          severity: "success",
                          summary: "Готово",
                          detail: "Заявка взята в обработку",
                          life: 3000,
                        });

                        setProcessModal({ visible: false, data: null });
                      } catch (err) {
                        console.error(err);
                        toast.current.show({
                          severity: "error",
                          summary: "Ошибка",
                          detail: "Не удалось взять заявку в обработку",
                          life: 3000,
                        });
                      }
                    }}
                  />
                )}
              </div>
              <div className="">
                {/* Кнопка создать заказ только если статус = 31 */}
                {processModal.data.status === 31 && (
                  <MyButton
                    label="Создать заказ"
                    onClick={async () => {
                      try {
                        const newTracking = generateTrackingCode();

                        const payload = {
                          ...processModal.data,
                          amount: processModal.data.price,
                          description: processModal.data.comment,
                          tracking_number: trackingNumber ?? newTracking,
                          link_order: processModal.data.link,
                          user_guid: processModal.data.user_guid,
                          order_guid: null,
                          guid: null,
                          status: 0,
                        };

                        await createOrUpdateOrder(payload).unwrap();

                        toast.current.show({
                          severity: "success",
                          summary: "Готово",
                          detail: "Заказ создан",
                          life: 3000,
                        });

                        setProcessModal({ visible: false, data: null });
                      } catch (err) {
                        console.error(err);
                        toast.current.show({
                          severity: "error",
                          summary: "Ошибка",
                          detail: "Не удалось создать заказ",
                          life: 3000,
                        });
                      }
                    }}
                  />
                )}

                <MyButton
                  severity="secondary"
                  label="Отмена"
                  onClick={() =>
                    setProcessModal({ visible: false, data: null })
                  }
                />
              </div>
            </div>
          </div>
        )}
      </Dialog>

      {/* Таблица */}
      <PresortDemo
        isLoading={isLoading}
        data={data}
        column={
          orderColumnTr.filter((i) => !i.hidden) ??
          Object.keys(data.data?.[0] || {})
        }
        toggleSidebar={toggleSidebar}
        deleteHandler={(row, field) => console.log(row, field)}
        actions={actions}
      />

      {id == 0 && (
        <SpeedDial
          model={items}
          radius={120}
          type="quarter-circle"
          onClick={() => toggleSidebar(true, {})}
          direction="up-left"
          style={{ right: 15, bottom: 15 }}
        />
      )}

      {/* Sidebar редактирования */}
      <Sidebar
        visible={visibleLeft.visible}
        position="right"
        onHide={() => toggleSidebar(false)}
        style={{ width: "50vw" }}
      >
        <div className="user-sidebar">
          {!formData?.guid && (
            <div className="inp_button">
              <div style={{ width: "calc(100% - 140px)" }}>
                <Editor
                  label={t("tracking_number")}
                  data={formData}
                  attr="tracking_number"
                />
              </div>
              <MyButton
                label={t("generateCod")}
                onClick={() =>
                  setFormData((prev) => ({
                    ...prev,
                    tracking_number: generateTrackingCode(),
                  }))
                }
              />
            </div>
          )}
          <div className="user-sidebar-edit">
            {orderColumnTr
              .filter((i) => i.editor)
              .map((el) => (
                <div key={el.attr}>
                  <Editor {...el} onBlur={onBlur} data={formData} />
                </div>
              ))}
            <MyButton
              label={t("save")}
              onClick={async () => {
                await createOrUpdateOrder(formData);
                toast.current.show({
                  severity: "info",
                  summary: "Success",
                  detail: t("successSaved"),
                  life: 3000,
                });
                toggleSidebar(false);
              }}
            />
          </div>
        </div>
      </Sidebar>

      <div ref={printRef} style={{ position: "absolute", left: "-9999px" }}>
        {printData && <ShippingLabel {...printData} />}
      </div>
    </>
  );
}

export default BuyForMe;
